export const whitelistedOrigins = [
  'https://ads.microsoft.com',
  'https://ui.ads.microsoft.com',
  'https://ads-int.microsoft.com',
  'https://ui.ads-int.microsoft.com',
  'https://about.ads.microsoft.com',
  'https://ui.beta.ads-int.microsoft.com',
  'https://app1.ui.ads-int.microsoft.com:12000', /* for local testing */
  'https://app1.ads-int.microsoft.com:12000', /* for local testing */

  'https://monetize.xandr.com', // Xandr Monetize Prod
  'https://curate.xandr.com', // Xandr Curate Prod
  'https://staging.monetize.xandr.com', // Xandr Monetize Staging
  'https://staging.curate.xandr.com', // Xandr Curate Staging
  'https://01-monetize-proxy-mui-jupiter.envnxs.net', // Monetize test env
];

export const checkifOriginIsWhitelisted = (origin = window.location.origin): boolean => whitelistedOrigins.includes(origin);
